import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Celebration from './container/celebration/celebration';
import Cookies from './container/cookies/CookieBanner';
import WhatsappButton from './container/whatsapp/whatsappButton';
import ModalToTop from './container/modalToTop/modalToTop';
import Home from './container/home/home';
import About from './container/about/About';
import Especialidades from './container/especialidades/especialidades';
import PsicologiaSistemica from './container/psicologiaSistemica/PsicoSistemica';
import Psicopedagogia from './container/psicopedagogia/Psicopedagogia';
import NeurologistaPediatra from './container/neurologistaPediatra/Neurologista';
import NeurologistaAdultos from './container/neurologistaAdulto/Neurologista';
import PsicoTccPage from "./container/psicologiaTcc/PsicoTcc";
import PsicoHumanista from './container/psicologiaHumanista/PsicoHumanista';
import Fonoaudiologia from './container/fonoaudiologia/Fonoaudiologia';
import Nutricao from './container/nutricao/Nutricao';
import Fisioterapia from './container/fisioterapia/Fisioterapia';
import Psiquiatria from './container/psiquiatria/Psiquiatria';
import TerapeutaCasais from './container/terapeutaCasais/TerapeutaCasais';
import Pedagoga from './container/pedagogo/Pedagogo';
import Clinica from './container/clinica/ClinicaDirection';
import Livros from './container/livros/Livros';
import Denuncia from './container/form/Denuncia';
import Footer from "./container/footer/Footer";

// Componente para scroll to top
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};


declare global {
  interface Window {
    VLibras: any;
  }
}

const VLibras = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
    script.async = true;
    script.onload = () => {
      // Inicializa o widget corretamente
      new window.VLibras.Widget('https://vlibras.gov.br/app');
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <VLibras />
    <ModalToTop />
    <Cookies />
    <WhatsappButton />
    <BrowserRouter>
      <ScrollToTop />
      <Celebration />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/especialidades" element={<Especialidades />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/especialidade/psicoHumanista" element={<PsicoHumanista />} />
        <Route path="/especialidade/psicologiaSistemica" element={<PsicologiaSistemica />} />
        <Route path="/especialidade/psicologiatcc" element={<PsicoTccPage />} />
        <Route path="/especialidade/psicoSistemica" element={<PsicologiaSistemica />} />
        <Route path="/especialidade/fonoaudiologia" element={<Fonoaudiologia />} />
        <Route path="/especialidade/psicopedagogia" element={<Psicopedagogia />} />
        <Route path="/especialidade/nutricao" element={<Nutricao />} />
        <Route path="/especialidade/fisioterapia" element={<Fisioterapia />} />
        <Route path="/especialidade/neurologistaPediatra" element={<NeurologistaPediatra />} />
        <Route path="/especialidade/neurologistaAdultos" element={<NeurologistaAdultos />} />
        <Route path="/especialidade/psiquiatria" element={<Psiquiatria />} />
        <Route path="/especialidade/terapeutaCasais" element={<TerapeutaCasais />} />
        <Route path="/especialidade/pedagogia" element={<Pedagoga />} />
        <Route path="/clinica" element={<Clinica />} />
        <Route path="/livros" element={<Livros />} />
        <Route path="/denuncia" element={<Denuncia />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  </React.StrictMode>
);
